var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBreadcrumbArrow = function SvgBreadcrumbArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#868686",
    d: "M1.17.5a1 1 0 0 0 0 1.41L4.71 5.5 1.17 9.04a1 1 0 1 0 1.42 1.41l4.24-4.24a1 1 0 0 0 0-1.42L2.59.5a1 1 0 0 0-1.42 0Z"
  })));
};
export default SvgBreadcrumbArrow;